import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { SetOriginalQuoteRequestId } from '@app/renewals/state/actions/renewals-module.actions';
import { CustomService } from '@app/custom/services/custom.service';

@Component({
  selector: 'app-renewals-journey',
  templateUrl: './renewals-journey.component.html',
  styleUrls: ['./renewals-journey.component.scss'],
})
export class RenewalsJourneyComponent implements OnInit {
  public originalQuoteRequestId?: number = null;

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private router: Router,
    private customService: CustomService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.originalQuoteRequestId = null;
      if (!isNaN(params.quoteRequestId)) {
        this.originalQuoteRequestId = params.quoteRequestId;
        this.store.dispatch(new SetOriginalQuoteRequestId(params.quoteRequestId));
      }
    });
  }

  navigateTo(quoteType: string): void {
    //Call the API with the original quoteRequestId.
    //The API will clone the existing quote request
    //into a new one with a new id.
    this.customService
      .getRenewalQuoteRequest(this.originalQuoteRequestId, quoteType)
      .pipe(
        catchError((result) => {
          // Handle the API error here
          this.openErrorDialog(result.error?.message || 'An error occurred');
          return of(null); // Return an observable so the pipeline continues
        })
      )
      .subscribe((renewalQuoteRequestId) => {
        if (renewalQuoteRequestId) {
          const route = [`/renewals-${quoteType}`, renewalQuoteRequestId, 'customer-details'];
          this.router.navigate(route);
        }
      });
  }

  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      data: errorMessage,
    });
  }
}
